(function () {
  const desktopQuery = window.matchMedia("(min-width: 750px)");

  function getNumber(value, fallback) {
    const parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? fallback : parsed;
  }

  function getSliderSettings(section) {
    const isDesktop = desktopQuery.matches;
    const mode = isDesktop
      ? section.dataset.desktopSliderMode || "manual"
      : section.dataset.mobileSliderMode || "manual";
    const autoplayDelay = getNumber(
      isDesktop ? section.dataset.desktopAutoplayDelay : section.dataset.mobileAutoplayDelay,
      4
    );
    const scrollDuration = getNumber(
      isDesktop ? section.dataset.desktopScrollDuration : section.dataset.mobileScrollDuration,
      8
    );

    return {
      mode: mode,
      isAutoplay: mode === "autoplay",
      isContinuous: mode === "continuous",
      isAutomated: mode === "autoplay" || mode === "continuous",
      autoplayDelay: autoplayDelay,
      scrollDuration: scrollDuration,
      pauseOnHover: section.dataset.pauseAutoOnHover === "true",
      disableOnInteraction: section.dataset.disableAutoOnInteraction === "true"
    };
  }

  function resetClonedSlides(slider) {
    slider
      .querySelectorAll(".swiper-slide[data-testimonial-clone='true']")
      .forEach((slide) => slide.remove());
  }

  function initTestimonials(section) {
    if (!section || typeof Swiper === "undefined") return;

    const slider = section.querySelector(".blj-testimonials__swiper");
    if (!slider || slider.dataset.initialized === "true") return;

    resetClonedSlides(slider);

    const wrapper = slider.querySelector(".swiper-wrapper");
    const slides = wrapper.querySelectorAll(".swiper-slide");
    const originalSlidesCount = slides.length;
    const settings = getSliderSettings(section);
    let totalSlides = originalSlidesCount;
    if (totalSlides <= 1) return;

    slider.dataset.initialized = "true";
    slider.dataset.sliderMode = settings.mode;

    // Fix for Swiper 11: If slides per view (3) equals total slides (3),
    // Swiper often fails to generate enough clones, leaving blank spaces.
    // By physically duplicating the DOM nodes before initialization,
    // we give Swiper 6 slides, ensuring flawless infinite looping.
    if (totalSlides === 3 || settings.isAutomated) {
      slides.forEach((slide) => {
        const clone = slide.cloneNode(true);
        // Remove shopify block attributes from clones to prevent theme editor conflicts
        clone.removeAttribute("data-shopify-editor-block");
        clone.dataset.testimonialClone = "true";
        wrapper.appendChild(clone);
      });
      // totalSlides is now updated to reflect the new DOM
      totalSlides = wrapper.querySelectorAll(".swiper-slide").length;
    }

    const swiperOptions = {
      centeredSlides: true,
      centeredSlidesBounds: false,
      loop: settings.isAutomated ? originalSlidesCount > 1 : originalSlidesCount > 2,
      watchOverflow: false,
      speed: settings.isContinuous ? settings.scrollDuration * 1000 : 600,
      spaceBetween: 0,
      slidesPerView: 1,
      roundLengths: true,
      // Start at index 1 (the original 2nd slide) to align perfectly with pre-JS CSS layout
      initialSlide: settings.isContinuous ? 0 : originalSlidesCount > 2 ? 1 : 0,
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      updateOnWindowResize: true,

      // Utilize native Swiper navigation for reliable transition-end looping
      navigation: {
        nextEl: section.querySelector(".blj-testimonials__arrow--next"),
        prevEl: section.querySelector(".blj-testimonials__arrow--prev"),
      },

      breakpoints: {
        750: {
          slidesPerView: Math.min(3, originalSlidesCount),
          centeredSlides: true,
          spaceBetween: 0
        }
      }
    };

    if (settings.isAutomated) {
      swiperOptions.autoplay = {
        delay: settings.isContinuous ? 0 : settings.autoplayDelay * 1000,
        disableOnInteraction: settings.disableOnInteraction,
        pauseOnMouseEnter: settings.pauseOnHover
      };
    }

    const swiper = new Swiper(slider, swiperOptions);

    slider.swiperInstance = swiper;
  }

  function destroyTestimonials(section) {
    const slider = section && section.querySelector(".blj-testimonials__swiper");
    if (!slider || slider.dataset.initialized !== "true") return;

    if (slider.swiperInstance) {
      slider.swiperInstance.destroy(true, true);
      slider.swiperInstance = null;
    }

    slider.dataset.initialized = "false";
    slider.removeAttribute("data-slider-mode");
    resetClonedSlides(slider);
  }

  function reloadAll() {
    document.querySelectorAll("[data-testimonials-section]").forEach((section) => {
      destroyTestimonials(section);
      initTestimonials(section);
    });
  }

  function initAll() {
    document
      .querySelectorAll("[data-testimonials-section]")
      .forEach(initTestimonials);
  }

  document.addEventListener("DOMContentLoaded", initAll);
  if (typeof desktopQuery.addEventListener === "function") {
    desktopQuery.addEventListener("change", reloadAll);
  } else if (typeof desktopQuery.addListener === "function") {
    desktopQuery.addListener(reloadAll);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initTestimonials(event.target);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    destroyTestimonials(event.target);
  });
})();

